import { render, staticRenderFns } from "./PicDialogSort.vue?vue&type=template&id=839f73d4&scoped=true"
import script from "./PicDialogSort.vue?vue&type=script&lang=js"
export * from "./PicDialogSort.vue?vue&type=script&lang=js"
import style0 from "./PicDialogSort.vue?vue&type=style&index=0&id=839f73d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839f73d4",
  null
  
)

export default component.exports